import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { io, Socket } from 'socket.io-client';
import { environment } from '../../environments/environment';
import { selectToken, selectTokenPayload } from '../store/auth/auth.reducer';
import { socketOptions } from './general-socket.config';

export abstract class BaseCompanySocketClass {
  protected socket: Socket | null = null;
  protected connecting = false;
  protected store = inject(Store);
  private jwtPayload = this.store.selectSignal(selectTokenPayload);
  private token = this.store.selectSignal(selectToken);

  protected abstract getNamespace(): string;

  protected abstract registerListeners(socket: Socket): void;

  protected connectWithAuth(authExtras?: Record<string, unknown>): void {
    const payload = this.jwtPayload();
    const token = this.token();
    if (!payload || !token) return;
    if (this.socket || this.connecting) return;

    this.connecting = true;
    const auth = {
      companyId: payload.companyId,
      userId: payload.userId,
      token,
      ...authExtras,
    };
    this.socket = io(`${environment.apiBaseUrl}/${this.getNamespace()}`, {
      ...socketOptions,
      auth,
    });

    this.registerListeners(this.socket);
    this.socket.on('connect', () => {
      this.connecting = false;
    });
    this.socket.on('connect_error', () => {
      this.connecting = false;
    });
  }

  disconnect(): void {
    if (this.socket) {
      this.socket.removeAllListeners();
      this.socket.disconnect();
      this.socket = null;
      this.connecting = false;
    }
  }

  isConnected(): boolean {
    return this.socket?.connected ?? false;
  }
}
